import styled from "styled-components";
import {menuActiveBackgroundColour, menuTextColor} from "../../../style/styleConsts";
import {NavLink} from "react-router-dom";

export const NavItem = styled(NavLink)`
    padding: 7px 12px;
    text-decoration: none;
    color: ${menuTextColor};
    cursor: pointer;
    font-weight: bold;
    
    &:hover {
        background-color: ${menuActiveBackgroundColour};
        color: white;
    }
    &:active {
        background-color: ${menuActiveBackgroundColour};
    }
    &.current {
        color: white;
        background-color: ${menuActiveBackgroundColour};
    }
`;